import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import CustomButton from "../../components/Helpers/CustomButton";
import { useHistory } from "react-router-dom";

export default function ReportMoveOuts() {
    const { current_staff } = useSelector((state) => state.auth);
    const { settings, years } = useSelector((state) => state.settings);
    const { properties } = useSelector((state) => state.properties);
    const history = useHistory();
    const [allowClick, setAllowClick] = useState(true);
    
    const [selectedYear, setSelectedYear] = useState(3); // Default to 2025 (year_id 3)
    const [propertyId, setPropertyId] = useState(0);
    const [fromDate, setFromDate] = useState(new Date(new Date().getFullYear(), 0, 1));
    const [toDate, setToDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [bookedData, setBookedData] = useState(null);
    const [doneData, setDoneData] = useState(null);
    const [notBookedData, setNotBookedData] = useState(null);

    useEffect(async () => {
        if (history.action == "POP") {
            if (allowClick === true) {
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}channels`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}tagsList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}collectionList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}mentionList/${current_staff.id}`,
                });

                if (settings && settings.brokers === 1) {
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}brokers`,
                    });
                }

                setAllowClick(false);
            }
        }
    }, []);

    useEffect(() => {
        if (selectedYear && fromDate && toDate) {
            fetchSummary();
        }
    }, [selectedYear, fromDate, toDate, propertyId]);

    const fetchSummary = async () => {
        setLoading(true);
        setBookedData(null);
        setDoneData(null);
        setNotBookedData(null);
        try {
            // Fetch booked data
            const bookedResponse = await axios.post(`${process.env.REACT_APP_API_URL}reports/move_outs_summary`, {
                year_id: selectedYear,
                property_id: propertyId,
                from_date: fromDate.toISOString().split('T')[0],
                to_date: toDate.toISOString().split('T')[0],
                filter: 'booked',
            });

            if (bookedResponse.data.success) {
                setBookedData(bookedResponse.data);
            }

            // Fetch done data
            const doneResponse = await axios.post(`${process.env.REACT_APP_API_URL}reports/move_outs_summary`, {
                year_id: selectedYear,
                property_id: propertyId,
                from_date: fromDate.toISOString().split('T')[0],
                to_date: toDate.toISOString().split('T')[0],
                filter: 'done',
            });

            if (doneResponse.data.success) {
                setDoneData(doneResponse.data);
            }

            // Fetch not booked data
            const notBookedResponse = await axios.post(`${process.env.REACT_APP_API_URL}reports/move_outs_summary`, {
                year_id: selectedYear,
                property_id: propertyId,
                from_date: fromDate.toISOString().split('T')[0],
                to_date: toDate.toISOString().split('T')[0],
                filter: 'not_booked',
            });

            if (notBookedResponse.data.success) {
                setNotBookedData(notBookedResponse.data);
            }
        } catch (error) {
            console.error("Error fetching summary:", error);
        } finally {
            setLoading(false);
        }
    };

    const downloadBookedReport = async () => {
        setLoading(true);
        try {
            const response = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}reports/export_move_outs_booked`,
                responseType: "blob",
                data: {
                    year_id: selectedYear,
                    property_id: propertyId,
                    from_date: fromDate.toISOString().split('T')[0],
                    to_date: toDate.toISOString().split('T')[0],
                },
            });

            const href = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "move_outs_booked.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch (error) {
            console.error("Error downloading booked report:", error);
            alert("Failed to download booked report");
        } finally {
            setLoading(false);
        }
    };

    const downloadDoneReport = async () => {
        setLoading(true);
        try {
            const response = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}reports/export_move_outs_done`,
                responseType: "blob",
                data: {
                    year_id: selectedYear,
                    property_id: propertyId,
                    from_date: fromDate.toISOString().split('T')[0],
                    to_date: toDate.toISOString().split('T')[0],
                },
            });

            const href = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "move_outs_done.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch (error) {
            console.error("Error downloading done report:", error);
            alert("Failed to download done report");
        } finally {
            setLoading(false);
        }
    };

    const downloadNotBookedReport = async () => {
        setLoading(true);
        try {
            const response = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}reports/export_move_outs_not_booked`,
                responseType: "blob",
                data: {
                    year_id: selectedYear,
                    property_id: propertyId,
                    from_date: fromDate.toISOString().split('T')[0],
                    to_date: toDate.toISOString().split('T')[0],
                },
            });

            const href = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "move_outs_not_booked.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch (error) {
            console.error("Error downloading not booked report:", error);
            alert("Failed to download not booked report");
        } finally {
            setLoading(false);
        }
    };

    const buttonClass = "inline-flex items-center px-6 py-2.5 rounded-lg border text-sm font-medium focus:z-10 focus:outline-none border-primary bg-primary text-white hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-out shadow-sm";

    return (
        <div className="w-auto bg-gray-100 my-6 xl:my-0 xl:mx-4 rounded-3xl flex-1 p-5">
            <h1 className="text-2xl font-bold mb-5">Move Outs Report</h1>

            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold mb-4">Filters</h2>
                
                <div className="grid lg:grid-cols-12 md:lg:grid-cols-6 gap-4 mb-5">
                    <div className="col-span-6 sm:col-span-3">
                        <label className="block text-sm font-medium text-gray-700">Year</label>
                        <select
                            className="block w-full font-light border border-gray-300 shadow-sm mt-1 py-2 pl-2 rounded-lg focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                        >
                            {years && years.length > 0 && years.map((year) => (
                                <option key={year.id} value={year.id}>{year.year}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="block text-sm font-medium text-gray-700">Property</label>
                        <select
                            className="block w-full font-light border border-gray-300 shadow-sm mt-1 py-2 pl-2 rounded-lg focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                            value={propertyId}
                            onChange={(e) => setPropertyId(parseInt(e.target.value))}
                        >
                            <option value={0}>All Properties</option>
                            {properties && properties.length > 0 && properties.map((property) => (
                                <option key={property.value} value={property.value}>{property.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="block text-sm font-medium text-gray-700">From Date</label>
                        <DatePicker
                            selected={fromDate}
                            onChange={(value) => setFromDate(value)}
                            className="z-20 block w-full font-light border border-gray-300 shadow-sm mt-1 py-2 pl-2 rounded-lg focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                            dateFormat={"d MMMM yyyy"}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="block text-sm font-medium text-gray-700">To Date</label>
                        <DatePicker
                            selected={toDate}
                            onChange={(value) => setToDate(value)}
                            className="z-20 block w-full font-light border border-gray-300 shadow-sm mt-1 py-2 pl-2 rounded-lg focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                            dateFormat={"d MMMM yyyy"}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold mb-4">Summary</h2>
                {loading ? (
                    <div className="flex items-center justify-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                        <div className="bg-blue-50 p-4 rounded-lg">
                            <p className="text-sm text-gray-600">Move Outs Booked</p>
                            <p className="text-3xl font-bold text-blue-600">{bookedData?.total || 0}</p>
                        </div>
                        <div className="bg-green-50 p-4 rounded-lg">
                            <p className="text-sm text-gray-600">Move Outs Done</p>
                            <p className="text-3xl font-bold text-green-600">{doneData?.total || 0}</p>
                        </div>
                        <div className="bg-red-50 p-4 rounded-lg">
                            <p className="text-sm text-gray-600">Move Out Not Booked</p>
                            <p className="text-3xl font-bold text-red-600">{notBookedData?.total || 0}</p>
                        </div>
                        <div className="bg-orange-50 p-4 rounded-lg">
                            <p className="text-sm text-gray-600">Year</p>
                            <p className="text-3xl font-bold text-orange-600">{bookedData?.year || doneData?.year || notBookedData?.year || ''}</p>
                        </div>
                        <div className="bg-purple-50 p-4 rounded-lg">
                            <p className="text-sm text-gray-600">Date Range</p>
                            <p className="text-lg font-bold text-purple-600">
                                {fromDate.toLocaleDateString()} - {toDate.toLocaleDateString()}
                            </p>
                        </div>
                    </div>
                )}
            </div>

            <div className="bg-white rounded-xl shadow-sm p-6">
                <h2 className="text-xl font-semibold mb-4">Download Excel Reports</h2>
                <div className="flex flex-wrap gap-3 mb-4">
                    <CustomButton
                        className={buttonClass}
                        text="Download Move Outs Booked"
                        onClick={downloadBookedReport}
                        loading={loading}
                    />
                    <CustomButton
                        className={buttonClass}
                        text="Download Move Outs Done"
                        onClick={downloadDoneReport}
                        loading={loading}
                    />
                    <CustomButton
                        className={buttonClass}
                        text="Download Move Out Not Booked"
                        onClick={downloadNotBookedReport}
                        loading={loading}
                    />
                </div>
                <div className="text-sm text-gray-600">
                    <p className="mb-2"><strong>Move Outs Booked:</strong> All students who booked a move out appointment with selected date.</p>
                    <p className="mb-2"><strong>Move Outs Done:</strong> All chats where move out form has been completed (move_out_at is set).</p>
                    <p><strong>Move Out Not Booked:</strong> 2025 residents who have not yet booked a move out appointment or moved out.</p>
                </div>
            </div>
        </div>
    );
}
